import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { MONTH_NAMES } from "nlib/ui/DatePicker/constants";
import DatePickerContainer from "nlib/ui/DatePicker/lib/DatePickerContainer";
import DatePickerContext from "nlib/ui/DatePicker/lib/DatePickerContext";
import DatePickerHeader from "nlib/ui/DatePicker/lib/DatePickerHeader";
import DatePickerMonth from "nlib/ui/DatePicker/lib/DatePickerMonth";
import React, { useCallback, useContext } from "react";

const DatePickerMonths = ({ translations, monthOnly, minDate, disabledMonthMessage, onSelect }) => {
  const {
    currentYear,
    currentMonth,
    setCurrentYear,
    setCurrentMonth,
    setYearsView
  } = useContext(DatePickerContext);

  const monthNamesTranslation = (translations && translations.months) || MONTH_NAMES;

  const disabledMonthsShown = minDate && new Date(currentYear, 0, 1) < minDate;

  const handlePrevClick = useCallback(() => {
    setCurrentYear((prev) => prev - 1);
    setCurrentMonth(null);
  }, [setCurrentYear, setCurrentMonth]);

  const handleNextClick = useCallback(() => {
    setCurrentYear((prev) => prev + 1);
    setCurrentMonth(null);
  }, [setCurrentYear, setCurrentMonth]);

  return (
    <DatePickerContainer monthOnly={monthOnly} className={Css.datePickerMonths}>
      <DatePickerHeader
        label={currentYear}
        onLabelClick={setYearsView}
        onPrevClick={handlePrevClick}
        onNextClick={handleNextClick} />
      <div className={Css.months}>
        {MONTH_NAMES.map((name, index) => (
          <DatePickerMonth
            key={name}
            month={index}
            disabled={(minDate && new Date(currentYear, index, 1) < minDate)}
            monthOnly={monthOnly}
            name={monthNamesTranslation[index]}
            selected={index === currentMonth}
            onSelect={onSelect} />
        ))}
      </div>
      {disabledMonthsShown && disabledMonthMessage && (
        <div className={Css.disabledMonthMessage}>
          <Icons.LockSimple weight="bold" />
          <span>{disabledMonthMessage}</span>
        </div>
      )}
    </DatePickerContainer>
  );
};

export default React.memo(DatePickerMonths);
